import Weather from "./Weather";
import Link from "./Link";

import "bootstrap/dist/css/bootstrap.css";

export default function App() {
  return (
    <div className="App">
      <Weather defaultCity="Toronto"/>
      <Link />
    </div>
  );
}
